import { PlusIcon } from 'components/ui/icons';
import React, { useState } from 'react';
import { Icon, Button } from 'semantic-ui-react';
import { plusButton } from '../PayoffTaxObjectsAndStyles';

interface IProps {
  type: string;
  removeSection: () => void;
  setSectionOpen: () => void;
  scrollToMyRef: () => void;
}

export default function ClosedSection(props: IProps) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  return (
    <>
      <div
        onClick={() => {
          props.setSectionOpen();
          props.scrollToMyRef();
        }}
        style={{ display: 'flex', justifyContent: 'space-between', position: 'relative' }}
      >
        <h2>{props.type}</h2>
        {confirmOpen ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div>Confirm Remove?</div>
            <Button
              size="small"
              color="green"
              onClick={e => {
                e.stopPropagation();
                props.removeSection();
                setConfirmOpen(false);
              }}
            >
              Yes
            </Button>
            <Button
              size="small"
              color="red"
              onClick={e => {
                e.stopPropagation();
                setConfirmOpen(false);
              }}
            >
              No
            </Button>
          </div>
        ) : (
          <div
            onClick={e => {
              e.stopPropagation();
              setConfirmOpen(true);
            }}
            style={{ cursor: 'pointer', position:'absolute', right: 100, color:'#D3D3D3' }}
          >
            <Icon circular name="trash alternate" size="small"  />
          </div>
        )}
        <span css={plusButton}>
          <PlusIcon />
        </span>
      </div>
    </>
  );
}
